/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import './index.scss'
import { Modal, Divider, List } from 'antd'
import { MailOutlined, MobileOutlined, QrcodeOutlined, SwapLeftOutlined, RightOutlined } from '@ant-design/icons'
import MFABindForm from './_components/mfaBindForm'
import intl from 'react-intl-universal'
import { px2rem } from '@/utils/utils'

const data = [
  {
    key: 'EMAIL',
    title: <span className='binding-type'><MailOutlined />{intl.get('mfa.bindSecurityEmail')}</span>,
    description: intl.get('mfa.bindEmailViaEmailVerificationCode')
  },
  {
    key: 'MOBILE',
    title: <span className='binding-type'><MobileOutlined />{intl.get('mfa.bindSecurityMobile')}</span>,
    description: intl.get('mfa.bindMobileViaSmsVerificationCode')
  },
  {
    key: 'TOTP',
    title: <span className='binding-type'><QrcodeOutlined />{intl.get('mfa.bindVirtualMfa')}</span>,
    description: intl.get('mfa.bindByScanningWithMobileMfaApp')
  }
]

class MandatoryMFABinding extends Component {
  state = {
    isBinding: false,
    bindingType: ''
  }

  handleBindType = (type) => {
    this.setState({
      isBinding: true,
      bindingType: type
    })
  }

  backToOtherBindType = () => {
    this.mfaBindForm && this.mfaBindForm.resetFields()
    this.setState({
      isBinding: false,
      bindingType: ''
    })
  }

  handleSuccess = () => {
    this.props.onConfirm()
  }

  /** 关闭弹窗 */
  handleCancel = () => {
    this.setState({
      isBinding: false,
      bindingType: ''
    })
    this.mfaBindForm && this.mfaBindForm.resetFields()
    this.props.onCancel()
  }

  render () {
    const { visible } = this.props
    const { isBinding, bindingType } = this.state
    return (
      <Modal className='bind-mfa-modal'
        title={isBinding
          ? <div className='back-other-bindType'><SwapLeftOutlined onClick={this.backToOtherBindType} />{intl.get('mfa.bindOtherMfaTypes')}</div>
          : '绑定MFA'}
        onCancel={this.handleCancel}
        open={visible}
        mask={{
          closable: false
        }}
        centered
        width={px2rem(1020)}
        footer={null}
      >
        <div className='bind-mfa-item'>
          {
            !isBinding && (
              <div className='bind-mfa-info'>
                <p className='bind-type-title'>{intl.get('mfa.selectMfaTypeToBind')}</p>
                <p>{intl.get('mfa.bindVirtualMfaTips1')}</p>
                <p>{intl.get('mfa.bindVirtualMfaTips2')}</p>
              </div>
            )
          }
          {
            bindingType === 'MOBILE' && (
              <div className='bind-mfa-info'>
                <p className='bind-type-title'>{intl.get('mfa.bindSecurityMobile')}</p>
                <p>{intl.get('mfa.bindMobileTips')}</p>
              </div>
            )
          }
          {
            bindingType === 'EMAIL' && (
              <div className='bind-mfa-info'>
                <p className='bind-type-title'>{intl.get('mfa.bindSecurityEmail')}</p>
                <p>{intl.get('mfa.bindEmailTips')}</p>
              </div>
            )
          }
          {
            bindingType === 'TOTP' && (
              <div className='bind-mfa-info'>
                <p className='bind-type-title'>{intl.get('mfa.bindVirtualMfa')}</p>
                <p>{intl.get('mfa.bindVirtualMfaTips1')}</p>
                <p>{intl.get('mfa.bindVirtualMfaTips2')}</p>
              </div>
            )
          }
          <Divider type='vertical' />
          {
            isBinding
              ? <MFABindForm ref={form => (this.mfaBindForm = form)} type={bindingType} onSuccess={this.handleSuccess} />
              : <div className='mfa-bind-type'>
                <List
                  itemLayout="horizontal"
                  dataSource={data}
                  renderItem={item => (
                    <List.Item onClick={() => this.handleBindType(item.key)}>
                      <List.Item.Meta
                        title={item.title}
                        description={item.description}
                      />
                      <RightOutlined />
                    </List.Item>
                  )}
                />
              </div>
          }
        </div>
      </Modal>
    )
  }
}

export default MandatoryMFABinding
